import React from 'react';
import Approutes from './Approutes';
import './styles.css';
function App() {
    return (
        <Approutes />
    );
}
export default App;